export default {
  title: '{type} migration State',
  confirmReset: {
    header: 'Reset migration status of {count} {type}?',
    message: 'All {type} are migrated again from the first data available in PT9800.',
  },
};
